import LoansService from '../../services/LoansService';
import toast from 'react-hot-toast';

// ============================================
// ACTION TYPES
// ============================================

// Get All Loans
export const GET_LOANS_REQUEST = 'GET_LOANS_REQUEST';
export const GET_LOANS_SUCCESS = 'GET_LOANS_SUCCESS';
export const GET_LOANS_FAILED = 'GET_LOANS_FAILED';

// Get Loan By Number
export const GET_LOAN_BY_NUMBER_REQUEST = 'GET_LOAN_BY_NUMBER_REQUEST';
export const GET_LOAN_BY_NUMBER_SUCCESS = 'GET_LOAN_BY_NUMBER_SUCCESS';
export const GET_LOAN_BY_NUMBER_FAILED = 'GET_LOAN_BY_NUMBER_FAILED';

// Get Loan Summary
export const GET_LOAN_SUMMARY_REQUEST = 'GET_LOAN_SUMMARY_REQUEST';
export const GET_LOAN_SUMMARY_SUCCESS = 'GET_LOAN_SUMMARY_SUCCESS';
export const GET_LOAN_SUMMARY_FAILED = 'GET_LOAN_SUMMARY_FAILED';

// Get Step Data
export const GET_CUSTOMER_STEP_REQUEST = 'GET_CUSTOMER_STEP_REQUEST';
export const GET_CUSTOMER_STEP_SUCCESS = 'GET_CUSTOMER_STEP_SUCCESS';
export const GET_CUSTOMER_STEP_FAILED = 'GET_CUSTOMER_STEP_FAILED';

export const GET_GUARANTOR_STEP_REQUEST = 'GET_GUARANTOR_STEP_REQUEST';
export const GET_GUARANTOR_STEP_SUCCESS = 'GET_GUARANTOR_STEP_SUCCESS';
export const GET_GUARANTOR_STEP_FAILED = 'GET_GUARANTOR_STEP_FAILED';

export const GET_VEHICLE_STEP_REQUEST = 'GET_VEHICLE_STEP_REQUEST';
export const GET_VEHICLE_STEP_SUCCESS = 'GET_VEHICLE_STEP_SUCCESS';
export const GET_VEHICLE_STEP_FAILED = 'GET_VEHICLE_STEP_FAILED';

export const GET_LOAN_DETAILS_STEP_REQUEST = 'GET_LOAN_DETAILS_STEP_REQUEST';
export const GET_LOAN_DETAILS_STEP_SUCCESS = 'GET_LOAN_DETAILS_STEP_SUCCESS';
export const GET_LOAN_DETAILS_STEP_FAILED = 'GET_LOAN_DETAILS_STEP_FAILED';

// Create Loan Application
export const CREATE_LOAN_REQUEST = 'CREATE_LOAN_REQUEST';
export const CREATE_LOAN_SUCCESS = 'CREATE_LOAN_SUCCESS';
export const CREATE_LOAN_FAILED = 'CREATE_LOAN_FAILED';

// Create Loan with Customer (Step 0-1)
export const CREATE_LOAN_WITH_CUSTOMER_REQUEST = 'CREATE_LOAN_WITH_CUSTOMER_REQUEST';
export const CREATE_LOAN_WITH_CUSTOMER_SUCCESS = 'CREATE_LOAN_WITH_CUSTOMER_SUCCESS';
export const CREATE_LOAN_WITH_CUSTOMER_FAILED = 'CREATE_LOAN_WITH_CUSTOMER_FAILED';

// Add Customer (Step 1)
export const ADD_CUSTOMER_REQUEST = 'ADD_CUSTOMER_REQUEST';
export const ADD_CUSTOMER_SUCCESS = 'ADD_CUSTOMER_SUCCESS';
export const ADD_CUSTOMER_FAILED = 'ADD_CUSTOMER_FAILED';

// Add KYC (Step 2)
export const ADD_KYC_REQUEST = 'ADD_KYC_REQUEST';
export const ADD_KYC_SUCCESS = 'ADD_KYC_SUCCESS';
export const ADD_KYC_FAILED = 'ADD_KYC_FAILED';

// Add Guarantor (Step 3)
export const ADD_GUARANTOR_REQUEST = 'ADD_GUARANTOR_REQUEST';
export const ADD_GUARANTOR_SUCCESS = 'ADD_GUARANTOR_SUCCESS';
export const ADD_GUARANTOR_FAILED = 'ADD_GUARANTOR_FAILED';

// Add Vehicle (Step 4)
export const ADD_VEHICLE_REQUEST = 'ADD_VEHICLE_REQUEST';
export const ADD_VEHICLE_SUCCESS = 'ADD_VEHICLE_SUCCESS';
export const ADD_VEHICLE_FAILED = 'ADD_VEHICLE_FAILED';

// Add Loan Details (Step 5)
export const ADD_LOAN_DETAILS_REQUEST = 'ADD_LOAN_DETAILS_REQUEST';
export const ADD_LOAN_DETAILS_SUCCESS = 'ADD_LOAN_DETAILS_SUCCESS';
export const ADD_LOAN_DETAILS_FAILED = 'ADD_LOAN_DETAILS_FAILED';

// Approve Loan
export const APPROVE_LOAN_REQUEST = 'APPROVE_LOAN_REQUEST';
export const APPROVE_LOAN_SUCCESS = 'APPROVE_LOAN_SUCCESS';
export const APPROVE_LOAN_FAILED = 'APPROVE_LOAN_FAILED';

// Reject Loan
export const REJECT_LOAN_REQUEST = 'REJECT_LOAN_REQUEST';
export const REJECT_LOAN_SUCCESS = 'REJECT_LOAN_SUCCESS';
export const REJECT_LOAN_FAILED = 'REJECT_LOAN_FAILED';

// Cancel Loan
export const CANCEL_LOAN_REQUEST = 'CANCEL_LOAN_REQUEST';
export const CANCEL_LOAN_SUCCESS = 'CANCEL_LOAN_SUCCESS';
export const CANCEL_LOAN_FAILED = 'CANCEL_LOAN_FAILED';

// Statistics
export const GET_LOAN_STATISTICS_REQUEST = 'GET_LOAN_STATISTICS_REQUEST';
export const GET_LOAN_STATISTICS_SUCCESS = 'GET_LOAN_STATISTICS_SUCCESS';
export const GET_LOAN_STATISTICS_FAILED = 'GET_LOAN_STATISTICS_FAILED';

export const GET_PENDING_BY_AGE_REQUEST = 'GET_PENDING_BY_AGE_REQUEST';
export const GET_PENDING_BY_AGE_SUCCESS = 'GET_PENDING_BY_AGE_SUCCESS';
export const GET_PENDING_BY_AGE_FAILED = 'GET_PENDING_BY_AGE_FAILED';

// Utility Actions
export const CLEAR_CURRENT_LOAN = 'CLEAR_CURRENT_LOAN';
export const CLEAR_LOAN_ERRORS = 'CLEAR_LOAN_ERRORS';
export const RESET_LOAN_SUCCESS = 'RESET_LOAN_SUCCESS';

// ============================================
// ACTION CREATORS
// ============================================

/**
 * Get all loans with pagination and filtering
 */
export const getLoansAction = (params = {}) => async (dispatch) => {
    try {
        dispatch({ type: GET_LOANS_REQUEST });
        
        const response = await LoansService.getAllLoans(params);
        
        if (response.status === 'success') {
            // Transform the data to match the expected structure
            const transformedLoans = response.data.map(loan => ({
                ...loan,
                // Transform customer data
                customer: {
                    name: loan.customerName,
                    mobileNumber: loan.customerMobileNumber || null,
                    aadhar: loan.customerAadhar
                },
                // Transform vehicle data
                vehicle: {
                    vehicleName: loan.vehicleName || null,
                    registrationNumber: loan.registrationNumber
                },
                // Map step to current step
                step: loan.currentStep,
                // Add any missing fields with defaults
                emiAmount: loan.emiAmount || null,
                emiMonths: loan.emiMonths || null
            }));

            dispatch({
                type: GET_LOANS_SUCCESS,
                payload: {
                    loans: transformedLoans,
                    pagination: response.pagination
                }
            });
        } else {
            dispatch({
                type: GET_LOANS_FAILED,
                payload: response.message || 'Failed to fetch loans'
            });
            toast.error(response.message || 'Failed to fetch loans');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to fetch loans';
        dispatch({
            type: GET_LOANS_FAILED,
            payload: errorMessage
        });
        toast.error(errorMessage);
    }
};

/**
 * Get loan by application number (full details)
 */
export const getLoanByNumberAction = (loanApplicationNumber) => async (dispatch) => {
    try {
        dispatch({ type: GET_LOAN_BY_NUMBER_REQUEST });
        
        const response = await LoansService.getLoanByNumber(loanApplicationNumber);
        
        if (response.status === 'success') {
            dispatch({
                type: GET_LOAN_BY_NUMBER_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_LOAN_BY_NUMBER_FAILED,
                payload: response.message || 'Failed to fetch loan details'
            });
            toast.error(response.message || 'Failed to fetch loan details');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to fetch loan details';
        dispatch({
            type: GET_LOAN_BY_NUMBER_FAILED,
            payload: errorMessage
        });
        toast.error(errorMessage);
    }
};

/**
 * Get loan summary (lightweight)
 */
export const getLoanSummaryAction = (loanApplicationNumber) => async (dispatch) => {
    try {
        dispatch({ type: GET_LOAN_SUMMARY_REQUEST });
        
        const response = await LoansService.getLoanSummary(loanApplicationNumber);
        
        if (response.status === 'success') {
            dispatch({
                type: GET_LOAN_SUMMARY_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_LOAN_SUMMARY_FAILED,
                payload: response.message || 'Failed to fetch loan summary'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_LOAN_SUMMARY_FAILED,
            payload: error.message || 'Failed to fetch loan summary'
        });
    }
};

/**
 * Get customer step data (Step 1 - GET)
 */
export const getCustomerStepAction = (loanApplicationNumber) => async (dispatch) => {
    try {
        dispatch({ type: GET_CUSTOMER_STEP_REQUEST });
        
        const response = await LoansService.getCustomerStep(loanApplicationNumber);
        
        if (response.status === 'success') {
            dispatch({
                type: GET_CUSTOMER_STEP_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_CUSTOMER_STEP_FAILED,
                payload: response.message || 'Failed to fetch customer data'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_CUSTOMER_STEP_FAILED,
            payload: error.message || 'Failed to fetch customer data'
        });
    }
};

/**
 * Get guarantor step data (Step 3 - GET)
 */
export const getGuarantorStepAction = (loanApplicationNumber) => async (dispatch) => {
    try {
        dispatch({ type: GET_GUARANTOR_STEP_REQUEST });
        
        const response = await LoansService.getGuarantorStep(loanApplicationNumber);
        
        if (response.status === 'success') {
            dispatch({
                type: GET_GUARANTOR_STEP_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_GUARANTOR_STEP_FAILED,
                payload: response.message || 'Failed to fetch guarantor data'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_GUARANTOR_STEP_FAILED,
            payload: error.message || 'Failed to fetch guarantor data'
        });
    }
};

/**
 * Get vehicle step data (Step 4 - GET)
 */
export const getVehicleStepAction = (loanApplicationNumber) => async (dispatch) => {
    try {
        dispatch({ type: GET_VEHICLE_STEP_REQUEST });
        
        const response = await LoansService.getVehicleStep(loanApplicationNumber);
        
        if (response.status === 'success') {
            dispatch({
                type: GET_VEHICLE_STEP_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_VEHICLE_STEP_FAILED,
                payload: response.message || 'Failed to fetch vehicle data'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_VEHICLE_STEP_FAILED,
            payload: error.message || 'Failed to fetch vehicle data'
        });
    }
};

/**
 * Get loan details step data (Step 5 - GET)
 */
export const getLoanDetailsStepAction = (loanApplicationNumber) => async (dispatch) => {
    try {
        dispatch({ type: GET_LOAN_DETAILS_STEP_REQUEST });
        
        const response = await LoansService.getLoanDetailsStep(loanApplicationNumber);
        
        if (response.status === 'success') {
            dispatch({
                type: GET_LOAN_DETAILS_STEP_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_LOAN_DETAILS_STEP_FAILED,
                payload: response.message || 'Failed to fetch loan details'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_LOAN_DETAILS_STEP_FAILED,
            payload: error.message || 'Failed to fetch loan details'
        });
    }
};

/**
 * Create new loan application (Step 0)
 */
export const createLoanAction = (navigate) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_LOAN_REQUEST });
        
        const response = await LoansService.createLoanApplication();
        
        if (response.status === 'success') {
            dispatch({
                type: CREATE_LOAN_SUCCESS,
                payload: response.data
            });
            toast.success(response.message || 'Loan application created successfully');
            
            // Navigate to add customer step with loan number
            if (navigate) {
                navigate(`/loans/${response.data.loanApplicationNumber}/customer`);
            }
        } else {
            dispatch({
                type: CREATE_LOAN_FAILED,
                payload: response.message || 'Failed to create loan application'
            });
            toast.error(response.message || 'Failed to create loan application');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to create loan application';
        dispatch({
            type: CREATE_LOAN_FAILED,
            payload: errorMessage
        });
        toast.error(errorMessage);
    }
};

/**
 * Create new loan application with customer data (Step 0-1)
 */
export const createLoanWithCustomerAction = (customerData, navigate) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_LOAN_WITH_CUSTOMER_REQUEST });
        
        const response = await LoansService.createLoanWithCustomer(customerData);
        
        if (response.status === 'success') {
            dispatch({
                type: CREATE_LOAN_WITH_CUSTOMER_SUCCESS,
                payload: response.data
            });
            toast.success(response.message || 'Loan application created successfully with customer');
            
            // Navigate to next step based on loan type
            if (navigate) {
                const loanNumber = response.data.id;
                const loanType = response.data.loanType || customerData.loanType;
                const nextPath = loanType === 'Loan Without Guarantor'
                    ? `/loans/${loanNumber}/vehicle`
                    : `/loans/${loanNumber}/guarantor`;
                navigate(nextPath);
            }
        } else {
            dispatch({
                type: CREATE_LOAN_WITH_CUSTOMER_FAILED,
                payload: response.message || 'Failed to create loan application',
                errors: response.errors
            });
            toast.error(response.message || 'Failed to create loan application');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to create loan application';
        dispatch({
            type: CREATE_LOAN_WITH_CUSTOMER_FAILED,
            payload: errorMessage,
            errors: error.errors
        });
        toast.error(errorMessage);
    }
};

/**
 * Add customer to loan application (Step 1)
 */
export const addCustomerAction = (loanApplicationNumber, customerData, navigate) => async (dispatch, getState) => {
    try {
        dispatch({ type: ADD_CUSTOMER_REQUEST });
        
        const response = await LoansService.addCustomer(loanApplicationNumber, customerData);
        
        if (response.status === 'success') {
            dispatch({
                type: ADD_CUSTOMER_SUCCESS,
                payload: response.data
            });
            toast.success(response.message || 'Customer added successfully');
            dispatch(resetLoanSuccess());
            
            // Navigate to next step based on loan type
            if (navigate) {
                const loanType = getState()?.loans?.currentLoan?.loanType || response.data.loanType;
                const nextPath = loanType === 'Loan Without Guarantor'
                    ? `/loans/${loanApplicationNumber}/vehicle`
                    : `/loans/${loanApplicationNumber}/guarantor`;
                navigate(nextPath);
            }
        } else {
            dispatch({
                type: ADD_CUSTOMER_FAILED,
                payload: response.message || 'Failed to add customer',
                errors: response.errors
            });
            toast.error(response.message || 'Failed to add customer');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to add customer';
        dispatch({
            type: ADD_CUSTOMER_FAILED,
            payload: errorMessage,
            errors: error.errors
        });
        toast.error(errorMessage);
    }
};

/**
 * Add KYC to loan application (Step 2)
 */
export const addKycAction = (loanApplicationNumber, kycData, navigate) => async (dispatch) => {
    try {
        dispatch({ type: ADD_KYC_REQUEST });
        
        const response = await LoansService.addKyc(loanApplicationNumber, kycData);
        
        if (response.status === 'success') {
            dispatch({
                type: ADD_KYC_SUCCESS,
                payload: response.data
            });
            toast.success(response.message || 'KYC added successfully');
            dispatch(resetLoanSuccess());
            
            // Navigate to next step (Guarantor)
            if (navigate) {
                navigate(`/loans/${loanApplicationNumber}/guarantor`);
            }
        } else {
            dispatch({
                type: ADD_KYC_FAILED,
                payload: response.message || 'Failed to add KYC',
                errors: response.errors
            });
            toast.error(response.message || 'Failed to add KYC');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to add KYC';
        dispatch({
            type: ADD_KYC_FAILED,
            payload: errorMessage,
            errors: error.errors
        });
        toast.error(errorMessage);
    }
};

/**
 * Add guarantor to loan application (Step 3)
 */
export const addGuarantorAction = (loanApplicationNumber, guarantorData, navigate) => async (dispatch, getState) => {
    try {
        dispatch({ type: ADD_GUARANTOR_REQUEST });
        
        const response = await LoansService.addGuarantor(loanApplicationNumber, guarantorData);
        
        if (response.status === 'success') {
            dispatch({
                type: ADD_GUARANTOR_SUCCESS,
                payload: response.data
            });
            toast.success(response.message || 'Guarantor added successfully');
            dispatch(resetLoanSuccess());
            
            // Navigate to next step: normally Vehicle, but skip Vehicle for loans without vehicle
            if (navigate) {
                try {
                    const loanType = getState()?.loans?.currentLoan?.loanType;
                    if (loanType === "Binding Loan Without Vehicle") {
                        navigate(`/loans/${loanApplicationNumber}/kyc`);
                    } else {
                        navigate(`/loans/${loanApplicationNumber}/vehicle`);
                    }
                } catch (e) {
                    // fallback to vehicle
                    navigate(`/loans/${loanApplicationNumber}/vehicle`);
                }
            }
        } else {
            dispatch({
                type: ADD_GUARANTOR_FAILED,
                payload: response.message || 'Failed to add guarantor',
                errors: response.errors
            });
            toast.error(response.message || 'Failed to add guarantor');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to add guarantor';
        dispatch({
            type: ADD_GUARANTOR_FAILED,
            payload: errorMessage,
            errors: error.errors
        });
        toast.error(errorMessage);
    }
};

/**
 * Add vehicle to loan application (Step 4)
 */
export const addVehicleAction = (loanApplicationNumber, vehicleData, navigate) => async (dispatch) => {
    try {
        dispatch({ type: ADD_VEHICLE_REQUEST });
        
        const response = await LoansService.addVehicle(loanApplicationNumber, vehicleData);
        
        if (response.status === 'success') {
            dispatch({
                type: ADD_VEHICLE_SUCCESS,
                payload: response.data
            });
            toast.success(response.message || 'Vehicle added successfully');
            dispatch(resetLoanSuccess());
            
            // Navigate to next step (Vehicle KYC)
            if (navigate) {
                navigate(`/loans/${loanApplicationNumber}/kyc`);
            }
        } else {
            dispatch({
                type: ADD_VEHICLE_FAILED,
                payload: response.message || 'Failed to add vehicle',
                errors: response.errors
            });
            toast.error(response.message || 'Failed to add vehicle');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to add vehicle';
        dispatch({
            type: ADD_VEHICLE_FAILED,
            payload: errorMessage,
            errors: error.errors
        });
        toast.error(errorMessage);
    }
};

/**
 * Add loan details (Step 5)
 */
export const addLoanDetailsAction = (loanApplicationNumber, loanDetails, navigate, callback) => async (dispatch) => {
    try {
        dispatch({ type: ADD_LOAN_DETAILS_REQUEST });
        const response = await LoansService.addLoanDetails(loanApplicationNumber, loanDetails);
        if (response.status === 'success') {
            dispatch({
                type: ADD_LOAN_DETAILS_SUCCESS,
                payload: response.data
            });
            dispatch(resetLoanSuccess());
            if (callback) {
                callback(response.message || 'Loan details added successfully', response.data, true);
            }
            return Promise.resolve(response.data);
        } else {
            dispatch({
                type: ADD_LOAN_DETAILS_FAILED,
                payload: response.message || 'Failed to add loan details',
                errors: response.errors
            });
            if (callback) {
                callback(response.message || 'Failed to add loan details', response.errors || null, false);
            }
            return Promise.reject(response);
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to add loan details';
        dispatch({
            type: ADD_LOAN_DETAILS_FAILED,
            payload: errorMessage,
            errors: error.errors
        });
        if (callback) {
            callback(errorMessage, error, false);
        }
        return Promise.reject(error);
    }
};

/**
 * Approve loan application with optional rounding
 */
export const approveLoanAction = (loanApplicationNumber, approvalDataOrCallback, callback) => async (dispatch) => {
    try {
        dispatch({ type: APPROVE_LOAN_REQUEST });
        // support (loanApplicationNumber, callback) or (loanApplicationNumber, approvalData, callback) or (loanApplicationNumber, approvalDate, callback)
        let data = {};
        let cb = callback;
        
        if (typeof approvalDataOrCallback === 'function') {
            cb = approvalDataOrCallback;
        } else if (typeof approvalDataOrCallback === 'object') {
            // It's an object with approvedDate and/or applyRounding
            data = approvalDataOrCallback;
        } else if (approvalDataOrCallback) {
            // It's just a date string (backward compatibility)
            data = { approvedDate: approvalDataOrCallback };
        }

        const response = await LoansService.approveLoanWithRounding(loanApplicationNumber, data);
        
        if (response.status === 'success') {
            dispatch({
                type: APPROVE_LOAN_SUCCESS,
                payload: response.data
            });
            toast.success(response.message || 'Loan approved successfully');
            dispatch(resetLoanSuccess());
            
            // Execute callback if provided
            if (cb) {
                cb();
            }
        } else {
            dispatch({
                type: APPROVE_LOAN_FAILED,
                payload: response.message || 'Failed to approve loan'
            });
            toast.error(response.message || 'Failed to approve loan');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to approve loan';
        dispatch({
            type: APPROVE_LOAN_FAILED,
            payload: errorMessage
        });
        toast.error(errorMessage);
    }
};

/**
 * Reject loan application
 */
export const rejectLoanAction = (loanApplicationNumber, reason, callback) => async (dispatch) => {
    try {
        dispatch({ type: REJECT_LOAN_REQUEST });
        
        const response = await LoansService.rejectLoan(loanApplicationNumber, reason);
        
        if (response.status === 'success') {
            dispatch({
                type: REJECT_LOAN_SUCCESS,
                payload: response.data
            });
            toast.success(response.message || 'Loan rejected successfully');
            dispatch(resetLoanSuccess());
            
            // Execute callback if provided
            if (callback) {
                callback();
            }
        } else {
            dispatch({
                type: REJECT_LOAN_FAILED,
                payload: response.message || 'Failed to reject loan'
            });
            toast.error(response.message || 'Failed to reject loan');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to reject loan';
        dispatch({
            type: REJECT_LOAN_FAILED,
            payload: errorMessage
        });
        toast.error(errorMessage);
    }
};

/**
 * Cancel loan application
 */
export const cancelLoanAction = (loanApplicationNumber, callback) => async (dispatch) => {
    try {
        dispatch({ type: CANCEL_LOAN_REQUEST });
        
        const response = await LoansService.cancelLoan(loanApplicationNumber);
        
        if (response.status === 'success') {
            dispatch({
                type: CANCEL_LOAN_SUCCESS,
                payload: response.data
            });
            toast.success(response.message || 'Loan cancelled successfully');
            dispatch(resetLoanSuccess());
            
            // Execute callback if provided
            if (callback) {
                callback();
            }
        } else {
            dispatch({
                type: CANCEL_LOAN_FAILED,
                payload: response.message || 'Failed to cancel loan'
            });
            toast.error(response.message || 'Failed to cancel loan');
        }
    } catch (error) {
        const errorMessage = error.message || 'Failed to cancel loan';
        dispatch({
            type: CANCEL_LOAN_FAILED,
            payload: errorMessage
        });
        toast.error(errorMessage);
    }
};

/**
 * Get company loan statistics
 */
export const getLoanStatisticsAction = (params = {}) => async (dispatch) => {
    try {
        dispatch({ type: GET_LOAN_STATISTICS_REQUEST });
        
        const response = await LoansService.getCompanyStatistics(params);
        if (response.status === 'success') {
            dispatch({
                type: GET_LOAN_STATISTICS_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_LOAN_STATISTICS_FAILED,
                payload: response.message || 'Failed to fetch loan statistics'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_LOAN_STATISTICS_FAILED,
            payload: error.message || 'Failed to fetch loan statistics'
        });
    }
};

/**
 * Get pending loans by age
 */
export const getPendingByAgeAction = () => async (dispatch) => {
    try {
        dispatch({ type: GET_PENDING_BY_AGE_REQUEST });
        
        const response = await LoansService.getPendingByAge();
        
        if (response.status === 'success') {
            dispatch({
                type: GET_PENDING_BY_AGE_SUCCESS,
                payload: response.data
            });
        } else {
            dispatch({
                type: GET_PENDING_BY_AGE_FAILED,
                payload: response.message || 'Failed to fetch pending loans by age'
            });
        }
    } catch (error) {
        dispatch({
            type: GET_PENDING_BY_AGE_FAILED,
            payload: error.message || 'Failed to fetch pending loans by age'
        });
    }
};

// ============================================
// UTILITY ACTIONS
// ============================================

/**
 * Clear current loan data
 */
export const clearCurrentLoan = () => ({
    type: CLEAR_CURRENT_LOAN
});

/**
 * Clear loan errors
 */
export const clearLoanErrors = () => ({
    type: CLEAR_LOAN_ERRORS
});

/**
 * Reset loan success state
 */
export const resetLoanSuccess = () => ({
    type: RESET_LOAN_SUCCESS
});
